import React, { useState } from "react";
import { Col, Collapse, Row } from "antd";
import { ReactComponent as VersionsHiddenIcon } from "../../../img/versions_icons/versionsHidden_icon.svg";
import { ReactComponent as VersionsShownIcon } from "../../../img/versions_icons/versionsShown_icon.svg";
import { ReactComponent as DotsIcon } from "../../../img/3dots.svg";
import { checkIsLoading } from "../../../lib/utils";
import { useAppDispatch, useAppSelector } from "../../..";
import {
  fetchOfferVersionsByIdWithParams,
  offeringActions,
} from "../../../store/slices/offering/offering";
import { ILoadByWithPromise, Offer } from "../../../lib/types";
import { IChangingRecordKeyNumber } from "../../../lib/types/IViewMode";
import HistoryAndPropertyModal from "../../HistoryAndPropertyModal/HistoryAndPropertyModal";
import { hasAccess } from "../../RolesModule/hasAccess";
import { MENU_ADMIN_OFFERING_WRITE } from "../../../lib/const/permissions";
import { useAccountProductsContainerContext } from "../../../containers/AccountProductsContainer/context/AccountProductsContainerContext";
import { OfferParamsView } from "../../OfferDetails/OfferParamsView/OfferParamsView";
import "./ProductsOfferParams.less";

export const ProductsOfferParams = () => {
  const { activeOfferVersion, setActiveOfferVersion } = useAccountProductsContainerContext();

  const dispatch = useAppDispatch();
  const { offerLoading, offerVersions, offerVersionsLoading } = useAppSelector(
    (state) => state.offering
  );
  const offer = (useAppSelector((state) => state.offering.offer) as unknown) as Offer;

  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [objectId, setObjectId] = useState<number | null>(null);

  const showHistoryModal = () => {
    setHistoryModalVisible(true);
    setObjectId(offer?.id || null);
  };

  const loadOfferVersions: ILoadByWithPromise = (id) =>
    dispatch(
      fetchOfferVersionsByIdWithParams({
        id,
        searchParams: {
          allObjectsVersions: true,
          withChars: true,
        },
      })
    );

  const [isVersionsOpen, setIsVersionsOpen] = useState<boolean>(false);
  const [isCollapseOpen, setIsCollapseOpen] = useState<boolean>(true);

  const toggleCollapse = () => {
    setIsCollapseOpen((prev) => !prev);
  };

  // Флаг редактируемой версии [индекс в массиве версий, mode]
  const [childChangingMode, setChildChangingMode] = useState<IChangingRecordKeyNumber>();

  const changeViewMode = (params?: IChangingRecordKeyNumber) => {
    setChildChangingMode(params);
  };

  const onClickVersionIcon = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.stopPropagation();
    if (isVersionsOpen) {
      dispatch(offeringActions.cleanOfferVersions());
      setChildChangingMode(undefined);
      setActiveOfferVersion(offer);
      setIsVersionsOpen(false);
    } else if (offer?.id) {
      loadOfferVersions(offer.id).then((res) => {
        if (res.payload) {
          const findActiveVersion = res.payload.find(
            (version) => version.fromDate === activeOfferVersion?.fromDate
          );
          if (findActiveVersion) {
            setActiveOfferVersion(findActiveVersion);
          }
        }
      });
      setIsVersionsOpen(true);
    }
  };

  const onChangeActiveOfferVersion = async (version: Offer) => {
    setActiveOfferVersion(version);
  };

  return (
    <>
      <Collapse activeKey={isCollapseOpen ? ["1"] : []} bordered={false} onChange={toggleCollapse}>
        <Collapse.Panel
          key="1"
          header={
            <Row justify="space-between" className="products-offer-params-container__pageTitle">
              <h3>Информация о предложении</h3>
              {isCollapseOpen && (
                <Row align="middle" gutter={21}>
                  <Col>
                    {isVersionsOpen && <VersionsShownIcon onClick={onClickVersionIcon} />}
                    {!isVersionsOpen && <VersionsHiddenIcon onClick={onClickVersionIcon} />}
                  </Col>
                  <Col>
                    <DotsIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        showHistoryModal();
                      }}
                    />
                  </Col>
                </Row>
              )}
            </Row>
          }
        >
          {offer && (
            <OfferParamsView
              offer={offer}
              isLoading={checkIsLoading(offerLoading, offerVersionsLoading)}
            />
          )}
          {isVersionsOpen &&
            offerVersions.map((version, idx) => (
              <div
                key={idx}
                style={
                  version.fromDate === activeOfferVersion?.fromDate
                    ? { border: "2px solid #4cf" }
                    : undefined
                }
                onClick={() => {
                  onChangeActiveOfferVersion(version);
                }}
              >
                {childChangingMode?.[0] !== idx && (
                  <OfferParamsView
                    isChild
                    changeViewMode={changeViewMode}
                    idx={idx}
                    offer={version}
                    isLatestVersion={idx === 0}
                    isEditingDisabled
                    isLoading={checkIsLoading(offerVersionsLoading)}
                  />
                )}
              </div>
            ))}
        </Collapse.Panel>
      </Collapse>
      <HistoryAndPropertyModal
        objectTypeSysname="offering"
        objectId={objectId}
        handleHideModal={() => setHistoryModalVisible(false)}
        visibleModal={historyModalVisible}
        hasAccessToEdit={hasAccess(MENU_ADMIN_OFFERING_WRITE)}
      />
    </>
  );
};
